<template>
    <tr v-show="!item.is_edit" @click="openEditLine(index)" :class="item.has_sales_general && 'bg-tr'">
        <td class="pl-10">
            <div class="col">
                <strong>
                  {{ item.name }}
                </strong>
                {{ item.description }}
            </div>
        </td>
        <td class="text-center">{{ item.service_resource_name || (item.service_resource ? item.service_resource.name : '') }}</td>
        <td class="text-center">{{ item.quantity }}</td>
        <td class="text-center">{{ item.rate }}</td>
        <td class="text-center">{{ item.amount }}</td>
        <td class="text-center">{{ item.discount_percent }}%</td>
        <td class="text-center">{{ item.discount_amount }}</td>
        <td class="text-center">{{ amountAfterDiscount }}</td>
        <td class="text-center">{{ totalAmount }}</td>
        <td class="text-center">{{ getBillDentition(item.dentition_pertains) }}</td>
        <td>
            <div class="d-flex justify-content-between">
                <button v-if="item.dentition_pertains && item.dentition_pertains.length > 0" @click="addOrEditTeeth()" class="btn btn-sm"><i class="fas fa-tooth"></i></button>
                <div v-else></div>
                <button @click="deleteItem(index)" class="btn btn-sm btn-dlt">
                    <i class="fas fa-trash"></i>
                </button>
            </div>
        </td>
    </tr>
    
    <tr v-show="item.is_edit" :class="item.is_edit && 'tr-box-shadow tr-edit'">
        <td style="min-width: 200px">
            <div class="col">
                <strong>
                    {{ item.name }}
                </strong>
                {{ item.description }}
            </div>
        </td>
        <td style="min-width: 200px">
          <AsyncSelect
            placeholder="Select service resource"
            v-model="item.service_resource"
            :api-service="fetchContactProfiles"
            :additional-query="additionalQuery"
          />
        </td>
        <td>
            <div class="td-inline">
                <input
                    v-model.trim="item.quantity"
                    type="number" class="form-control"
                    placeholder="Qty" :min="0"
                >
            </div>
        </td>
        <td>
            <div class="td-inline">
                <input
                    v-model.trim="item.rate"
                    type="number" class="form-control"
                    placeholder="Rate" :min="0"
                >
            </div>
        </td>
        <td>
            <div class="td-inline">
                <vField
                    readonly
                    v-model="amount"
                    name="amount text-right"
                    type="number"
                    class="form-control text-right"
                />
            </div>
        </td>
        <td>
            <div class="td-inline">
                <input
                    v-model.trim="item.discount_percent"
                    type="number" class="form-control"
                    placeholder="Discount(%)" :min="0"
                >
            </div>
        </td>
        <td>
            <div class="td-inline">
                <vField
                    v-model="item.discount_amount"
                    name="discount-amount"
                    type="number"
                    class="form-control text-right"
                    min="0"
                />
            </div>
        </td>
        <td>
            <div class="td-inline">
                <vField
                    v-model="amountAfterDiscount"
                    name="amount"
                    type="number"
                    class="form-control text-right"
                />
            </div>
        </td>
        <td>
            <div class="td-inline">
                <vField
                    v-model="totalAmount"
                    readonly
                    name="total_amount"
                    type="number"
                    class="form-control text-right"
                />
            </div>
        </td>
        <td class="text-center">{{ getBillDentition(item.dentition_pertains) }}</td>
        <td class="inline-action">
            <div class="d-flex justify-content-between">
                <button v-if="item.dentition_pertains && item.dentition_pertains.length > 0" @click="addOrEditTeeth()" class="btn btn-sm"><i class="fas fa-tooth"></i></button>
                <div v-else></div>
                <button @click="deleteItem(index)" class="btn btn-sm btn-dlt">
                    <i class="fas fa-trash"></i>
                </button>
            </div>
        </td>
    </tr>

</template>
<script setup>
import {computed, inject, onMounted, ref, watch} from "vue";
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import handleInventory from "@/services/modules/inventory";
import {useRoute} from "vue-router";
import handleContact from "@/services/modules/contact";
import handleHospital from "@/services/modules/hospital";

const props = defineProps(['item', 'index', 'onOpenEditItem', 'onDeleteItem', 'vatRate'])
const emit = defineEmits(['onOpenEditItem', 'onDeleteItem', 'addOrEditTeeth']);
const {fetchContactProfiles} = handleContact()
const {fetchServiceResource} = handleHospital();
const $route = useRoute();
const showError = inject('showError')
const companyId = $route.params.companyId
const additionalQuery = {
  roles: "doctor,medical_officer",
}
const serviceResourceDescriptions = ref([]);

const openEditLine = (i) => {
    emit('onOpenEditItem', i)
}
const deleteItem = (i) => {
    emit('onDeleteItem', i)
}

const amount = computed(() => props.item.amount = props.item.rate * props.item.quantity)
const discountPercent = computed(() => props.item.discount_percent);

const amountAfterDiscount = computed(() => {
    const discountAmount = props.item.discount_amount === '' ? 0 : parseFloat(props.item.discount_amount)
    return amount.value - discountAmount
})

const vatAmount = computed(() => {

    if(!props.item.vat) return 0;

    return (props.item.vat/100 * amountAfterDiscount.value).toFixed(2);
})

const serviceResourceId = computed(() => props.item.service_resource)
const serviceResourceDescId = computed(() => props.item.resource_description_id)

const totalAmount = computed(() => {
    if(!props.item.vat) {
        return props.item.total_amount = amountAfterDiscount.value
    }
    return props.item.total_amount = parseInt(amountAfterDiscount.value) + parseInt(props.item.vat_amount)
})

const getBillDentition = (dentitionPertains) => {
    if (!dentitionPertains || dentitionPertains.length === 0) {
        return '';
    }

    return dentitionPertains.filter(dentition => dentition.is_billed).map(dentition => dentition.tooth_number).join(', ').toUpperCase();
}

watch(vatAmount, (newValue, oldValue) => {
    if(isNaN(oldValue)){
        return props.item.vat_amount  = props.item.vat_amount;
    }
    props.item.vat_amount  = newValue;
})

const addOrEditTeeth = () => {
  emit('addOrEditTeeth', props.item)
}

watch(serviceResourceId, () => {

  serviceResourceDescriptions.value = [];

  if (serviceResourceId.value) {
    const companyQuery = `?company_id=${companyId}`;
    const previousDescriptionId = props.item.resource_description_id;
    const previousServiceResourcePrice = props.item.service_resource_price;

    props.item.service_resource_id = serviceResourceId.value.id
    props.item.service_resource_name = serviceResourceId.value.name
    props.item.resource_description_id = null;
    props.item.service_resource_desc_name = null;
    props.item.service_resource_price = null;
    props.item.cost_of_sales_account_head_id = null;

    fetchServiceResource(serviceResourceId.value.id, companyQuery).then(res => {
        if (res.data) {
            serviceResourceDescriptions.value = res.data.resource_descriptions.map(rd => {
                return {
                    ...rd,
                    name: rd.service_name + (rd.service_specification ? ` (${rd.service_specification})` : "")
                }
            })
        }

        const exists = serviceResourceDescriptions.value.find(desc => desc.id === previousDescriptionId);

        if (exists && res.data) {
            props.item.resource_description_id = previousDescriptionId;
            props.item.service_resource_price = previousServiceResourcePrice;
        }
    })
  }
}, {
  deep:true
})

watch(serviceResourceDescId, (newValue) => {
    if (newValue) {
        const description = serviceResourceDescriptions.value.find(srd => srd.id === newValue);
        props.item.service_resource_desc_name = description.name;
        props.item.service_resource_price = (props.item.resource_description_id === props.item.service_resource_description_id && props.item.service_resource_price) ?
        props.item.service_resource_price : description.cost_of_sales_price;
        props.item.cost_of_sales_account_head_id = description.cost_of_sales_account_head_id;
    }
})

watch(discountPercent, (value) => {
    let discount = 0;

    value = parseFloat(value);

    if(value && value > 0 && amount.value > 0) {
      discount = amount.value * (value/100);
    }

    props.item.discount_percent = value;
    props.item.discount_amount = discount.toFixed(2);
})

onMounted(() => {
    
    if(props.item.service_resource) {
        props.item.service_resource.name = props.item.service_resource.full_name || props.item.service_resource.name;
    }

    if(props.item.service_resource_description_id) {

        props.item.resource_description_id = props.item.service_resource_description_id;
        props.item.service_resource_price = props.item.service_resource_price ? props.item.service_resource_price : props.item.cost_of_sales_price;
        props.item.cost_of_sales_account_head_id = props.item.cost_of_sales_account_head_id;

        serviceResourceDescriptions.value.push({
            id: props.item.service_resource_description_id,
            name: props.item.service_resource_desc_name,
            cost_of_sales_price: props.item.cost_of_sales_price,
            cost_of_sales_account_head_id: props.item.cost_of_sales_account_head_id
        })
    }
});

</script>

<style scoped>
.bg-tr{
    background-color: rgb(187, 247, 208);
    color: rgb(22, 101, 52);
}
.bg-tr:hover{
    background-color: rgb(187, 247, 208) !important;
    color: rgb(22, 101, 52) !important;
}
.table > tbody > .bg-tr:hover {
    --bs-table-accent-bg: rgb(187, 247, 208) !important;
    color: rgb(22, 101, 52) !important;
}
.inline-action{
    min-width: 100px;
}
.btn-dlt{
    color: #ea5455;
}
.tr-edit td{
  min-width: 80px;
}
</style>